module.exports = __webpack_public_path__ + "static/img/22340069.f917101d.png";